module.exports = __webpack_public_path__ + "img/img (40).7638c654.jpg";